import React, { useState, useEffect } from "react";
import { useFetcher, useLocation } from "react-router-dom";
import { hooks } from "../hooks";
import { svg } from "../assets/svg";
import { components } from "../components";
import { CrossSvg } from "../assets/svg/CrossSvg";
import locationAllow from "../assets/nestfin/map.png";
import useApi from "../customHook/useApi";
import { updateLeadProfile, viewLeadProfile } from "../environment";

const price = [
  {
    id: 1,
    name: "Paid (142)",
  },
  {
    id: 2,
    name: "Free (18)",
  },
];

type Profile = {
  leadId: string | null;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;
};

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  message?: string;
}

export const Onboarding5: React.FC = () => {
  const [formData, setFormData] = useState({
    leadId: "",
    full_name: "",
    email: "",
    phone_number: "",
    gender: "",
    dob: "",
    pref_budget_min_range: "",
    pref_budget_max_range: "",
    pref_city_name: "",
    pref_city_id: "",
    pref_locality_name: "",
    pref_locality_id: "",
  });

  const location = useLocation();
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const navigate = hooks.useNavigate();

  const [selectedPrice, setSelectedPrice] = useState<number | null>(
    price[0].id
  );
  const [searchInput, setSearchInput] = useState<string>("");
  const [selectedCity, setSelectedCity] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [error, setError] = useState(false);

  const handleUseLocation = () => {
    setShowLocationPopup(true);
    // if ('geolocation' in navigator) {
    //     navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //             const latitude = position.coords.latitude;
    //             const longitude = position.coords.longitude;

    //             console.log('Latitude:', latitude);
    //             console.log('Longitude:', longitude);

    //             // You can use latitude and longitude here to fetch address or nearby data
    //         },
    //         (error) => {
    //             console.error('Geolocation error:', error.message);
    //             alert('Unable to fetch location. Please allow location access.');
    //         }
    //     );
    // } else {
    //     alert('Geolocation is not supported in your browser.');
    // }
  };

  // const handleApply = () => {
  //     if (!searchInput.trim()) {
  //         setError(true)
  //         return;
  //     }
  //     localStorage.setItem("selectedCity", searchInput)
  //     localStorage.setItem("selectedCity", searchInput);
  //     navigate("/onbording6", { state: { cityName: searchInput } });
  // };

  // handleCityTab

  const handleCityTab = (cityname: string) => {
    console.log(cityname, "this is city name");
    setSearchInput(cityname);
    localStorage.setItem("selectedCity", cityname);
    localStorage.setItem("selectedCity", cityname);
    navigate("/onbording6", { state: { cityname } });
  };

  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      const selectedCity = localStorage.getItem("selectedCity")?.trim();

      if (!selectedCity) {
        setcityAlertPopup(true);
        // Optionally, keep the user on the same page
        navigate("/onbording5", { replace: true });
      }
      // If city is already selected, do nothing, allow normal back navigation
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  // const citiesArray = [
  //     { id: 1, city: "Delhi" },
  //     { id: 2, city: "New Delhi" },
  //     { id: 3, city: "Noida" },
  //     { id: 4, city: "Greater Noida" },
  //     { id: 5, city: "Gurugram" },
  //     { id: 6, city: "Faridabad" },
  //     { id: 7, city: "Ghaziabad" },
  // ];

  // const filteredCity = citiesArray.filter(city => city.city.toLowerCase().includes(searchInput.toLowerCase()))

  // useEffect(() => {
  //     console.log("Filtered Cities:", filteredCity);
  // }, [filteredCity]);

  const handleCityClick = (city: string) => {
    console.log(city, "city from dropdown");
    setSearchInput(city); // Show the city name in input
    setSelectedCity(city); // Optional: track selected city
    setShowDropdown(false);

    if (!city.trim()) {
      setError(true);
      return;
    }
    localStorage.setItem("selectedCity", city);
    localStorage.setItem("selectedCity", city);
    navigate("/onbording6");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInput(value);
    setShowDropdown(value.length > 0); // Show dropdown if input has text
  };

  const handleClearInput = () => {
    setSearchInput("");
    setShowDropdown(false);
  };

  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [cityAlertPopup, setcityAlertPopup] = useState(false);

  // useEffect(() => {
  //     // alert("Open Your Current Location")
  //     // Open popup on mount
  //     const hasSeenPopup = localStorage.getItem("locationPopupShown");
  //     if (!hasSeenPopup) {
  //         setTimeout(() => {
  //             setShowLocationPopup(true);
  //             localStorage.setItem("locationPopupShown", "true");
  //         }, 1000);
  //     }
  // }, [pathname])

  const hanldeAllowLocation = (location: string) => {
    setShowLocationPopup(false);

    if (location === "Allow") {
      console.log("this is Allow Block");

      if (navigator.geolocation) {
        console.log("onbording5 --->>> geolocation", navigator.geolocation);

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            console.log("User location:", latitude, longitude);

            // You can use these coordinates to fetch nearby options or update your app state
          },
          (error) => {
            console.error("Geolocation error:", error.message);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }

    if (location === "Don't Allow") {
      console.log("This is Don't Allow Block");
    }
  };

  const handleCityClick2 = (selectedCity: string) => {
    // console.log("City selected:", selectedCity);

    // Find the full city object by name
    const city = locationMap.find((c) => c.cityName === selectedCity);

    // console.log(city, "641646464646");

    if (city) {
      localStorage.setItem("selectedCity", city.cityName);
      localStorage.setItem("selectedCityId", city.id.toString());

      localStorage.removeItem("selectedLatLng");
      localStorage.removeItem("selectedLocality");
    }
    // console.log(formData, "From data from city ");

    const payload = {
      ...formData,
      pref_city_id: city ? Number(city.id) : formData.pref_city_id || null,
      pref_city_name: city ? city.cityName : formData.pref_city_name || "",
    };

    updatePayload(payload);

    navigate("/onbording6");
  };

  // View Profile API CALL
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  // 2. Populate formData when API response arrives
  useEffect(() => {
    if (profileData?.data) {
      const data = profileData.data;

      const lead_profile_id = localStorage.getItem("lead_profile_id") ?? "";
      setFormData({
        leadId: lead_profile_id ?? "",
        full_name: data.full_name ?? "",
        email: data.email ?? "",
        phone_number: data.phone_number ?? "",
        gender: data.gender ?? "",
        dob: data.dob || "",
        pref_budget_min_range: String(data.pref_budget_min_range ?? ""),
        pref_budget_max_range: String(data.pref_budget_max_range ?? ""),
        pref_city_name: data.pref_city_name ?? "",
        pref_city_id: formData.pref_city_id ?? "",
        pref_locality_name: formData.pref_locality_name ?? "",
        pref_locality_id: formData.pref_locality_id ?? "",
      });
    }
  }, [profileData]); // ✅ Dependency is profileData

  // update profile

  // UPDATE PROFILE API
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    if (UpdateProfileData?.success) {
      // console.log("Profile updated successfully");
      // Optionally show toast/snackbar/redirect
      // toast.success("Profile updated successfully");
      localStorage.setItem("selectedCity", formData.pref_city_name);
      localStorage.setItem("selectedCityId", formData.pref_city_id);
      // setIsModalOpen(true);
    }
  }, [UpdateProfileData]);

  // ***********Start the Reuseable Component*********************************
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title=""
        goBack={true}
        // skip={true}
        clear={false}
        clearOnClicked={() => {}}
      />
    );
  };

  const renderTitle = (): JSX.Element => {
    return (
      <div className="container" style={{ marginTop: 30 }}>
        <p className="headingCity"> You are looking to rent in</p>
      </div>
    );
  };

  const renderSearchBar = (): JSX.Element => {
    return (
      <div className="container">
        {/* <div className="searchBar" style={{ border: error ? "1px solid red" : "1px solid #ddd", }}>
                    <span><svg.SearchSvg /></span>
                    <input
                        type="text"
                        placeholder="Search City here"
                        className="searchInput"
                        maxLength={30}
                        value={searchInput}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (error) setError(false);
                        }}

                    />

                    {
                        searchInput && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
                            <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

                        </span>
                    }

                </div>

                {showDropdown && (
                    <div className='localityResult'>
                        {filteredCity.length > 0 ? (
                            filteredCity.map((city, index) => (
                                <p key={index} onClick={() => handleCityClick(city.city)}>{city.city}</p>
                            ))
                        ) : (
                            <p style={{ backgroundColor: "#f0f0f0", color: "#333" }}>No cities found</p>
                        )}
                    </div>
                )}

                {
                    error && <div style={{ fontSize: "15px", color: "red" }}>
                        Please Enter & Select City Name
                    </div>
                } */}
        {/* <div className="useLocation" onClick={handleUseLocation}>
                    <svg.LocationSvg />
                    <span >Use My Current Location</span>
                </div> */}
      </div>
    );
  };

  const renderDescription = (): JSX.Element => {
    return (
      <div className="container" style={{ marginTop: 10 }}>
        <p className="paraCity">
          Choose a city here which can be changed later on
        </p>
      </div>
    );
  };
  const renderDescription1 = (): JSX.Element => {
    return (
      <div className="container" style={{ marginTop: 40 }}>
        <p className="popularCity">
          Please select your <span> City</span>{" "}
        </p>
      </div>
    );
  };

  const locations = ["Delhi", "Noida", "Gurugram"];

  // OLD LOCATION GRID
  const renderLocationGrid = (): JSX.Element => {
    return (
      <div className="container">
        <div className="location-container">
          <div className="location-scroll">
            <div className="location-grid">
              {locations?.map((city, index) => (
                <div
                  className="location-card"
                  key={index}
                  onClick={() => handleCityTab(city)}
                >
                  {city}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const locationMap = [
    {
      id: 1,
      cityName: "Delhi",
      cityImage: require("../assets/nestfin/delhi.png"),
    },
    {
      id: 2,
      cityName: "Noida",
      cityImage: require("../assets/nestfin/noida.png"),
    },
    {
      id: 7,
      cityName: "Greater Noida",
      cityImage: require("../assets/nestfin/greater_noida.png"),
    },
    {
      id: 3,
      cityName: "Gurugram",
      cityImage: require("../assets/nestfin/grugram.png"),
    },
  ];

  const renderLocationGrid2 = () => {
    return (
      <div className="loc-grid-container">
        {locationMap.map((city, index) => (
          <div
            className="loc-grid-card"
            key={index}
            onClick={() => handleCityClick2(city.cityName)}
          >
            <div className="loc-card-image">
              <img src={city.cityImage} alt="" />
            </div>
            <span className="loc-card-title"> {city.cityName}</span>
          </div>
        ))}
      </div>
    );
  };

  // const renderLocationGrid2 = (): JSX.Element => {
  //   return (
  //     <div className="container">
  //       <div className="cityContainer">
  //         {locationMap?.map((city, index) => (
  //           <div
  //             className="cities"
  //             style={{ backgroundImage: `url(${city.cityImage})` }}
  //             key={index}
  //             onClick={() => handleCityClick2(city.cityName)}
  //           >
  //             <span className="city-name">{city.cityName}</span>
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // };

  // const renderButton = (): JSX.Element => {
  //     return (

  //         <div
  //             id="onbording3"
  //             style={{ backgroundColor: "#7065F0", color: "white" }}
  //             onClick={handleApply}
  //         >
  //             <span>Apply</span>
  //         </div>
  //     );
  // };

  const renderContent = (): JSX.Element => {
    return (
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100dvh",
          paddingBottom: 10,
          overflow: "hidden",
        }}
      >
        <div style={{ overflowY: "auto" }}>
          {renderTitle()}
          {renderDescription()}
          {renderDescription1()}
          {renderSearchBar()}
          {renderLocationGrid2()}
          {/* {renderLocationGrid()} */}
        </div>
        {/* 
                <div style={{ padding: '0 20px 10px' }}>
                    {renderButton()}
                </div> */}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {showLocationPopup && (
        <div className="location-overlay">
          <div className="location-modal">
            <div className="location-buttons">
              <div className="img-container">
                <img src={locationAllow} alt="Location" width="100" />
              </div>
              <div className="locationContent">
                <h3>Allow your location </h3>
                <p>
                  To help you find the best options near you, we need access to
                  your location. Your privacy is important to us.
                </p>
              </div>
              <button
                className="allow-btn"
                onClick={() => hanldeAllowLocation("Allow")}
              >
                Allow{" "}
              </button>
              <button
                className="deny-btn"
                onClick={() => hanldeAllowLocation("Don't Allow")}
              >
                Don't Allow
              </button>
            </div>
          </div>
        </div>
      )}

      {cityAlertPopup && (
        <div className="location-overlay">
          <div className="location-modal">
            <div className="location-buttons">
              <div className="locationContent" style={{ textAlign: "center" }}>
                <h3>Please select your city</h3>
                <p>
                  To continue, you need to select your preferred city. This
                  helps us show you the most relevant options.
                </p>
              </div>
              <button
                className="allow-btn"
                onClick={() => setcityAlertPopup(false)}
                style={{ marginTop: 10 }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// CODE 08-07-2025
// import React, { useState, useEffect } from 'react';
// import { useFetcher, useLocation } from 'react-router-dom';
// import { hooks } from '../hooks';
// import { svg } from '../assets/svg';
// import { components } from '../components';
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import locationAllow from '../assets/nestfin/map.png'

// const price = [
//     {
//         id: 1,
//         name: 'Paid (142)',
//     },
//     {
//         id: 2,
//         name: 'Free (18)',
//     },
// ];

// export const Onboarding5: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [selectedPrice, setSelectedPrice] = useState<number | null>(price[0].id);
//     const [searchInput, setSearchInput] = useState<string>('');
//     const [selectedCity, setSelectedCity] = useState("");
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [error, setError] = useState(false);

//     const handleUseLocation = () => {
//         setShowLocationPopup(true)
//         // if ('geolocation' in navigator) {
//         //     navigator.geolocation.getCurrentPosition(
//         //         (position) => {
//         //             const latitude = position.coords.latitude;
//         //             const longitude = position.coords.longitude;

//         //             console.log('Latitude:', latitude);
//         //             console.log('Longitude:', longitude);

//         //             // You can use latitude and longitude here to fetch address or nearby data
//         //         },
//         //         (error) => {
//         //             console.error('Geolocation error:', error.message);
//         //             alert('Unable to fetch location. Please allow location access.');
//         //         }
//         //     );
//         // } else {
//         //     alert('Geolocation is not supported in your browser.');
//         // }
//     };

//     // const handleApply = () => {
//     //     if (!searchInput.trim()) {
//     //         setError(true)
//     //         return;
//     //     }
//     //     localStorage.setItem("selectedCity", searchInput)
//     //     localStorage.setItem("selectedCity", searchInput);
//     //     navigate("/onbording6", { state: { cityName: searchInput } });
//     // };

//     // handleCityTab

//     const handleCityTab = (cityname: string) => {
//         console.log(cityname, "this is city name");
//         setSearchInput(cityname);
//         localStorage.setItem("selectedCity", cityname);
//         navigate("/onbording6", { state: { cityname } });
//     }

//     // const citiesArray = [
//     //     { id: 1, city: "Delhi" },
//     //     { id: 2, city: "New Delhi" },
//     //     { id: 3, city: "Noida" },
//     //     { id: 4, city: "Greater Noida" },
//     //     { id: 5, city: "Gurugram" },
//     //     { id: 6, city: "Faridabad" },
//     //     { id: 7, city: "Ghaziabad" },
//     // ];

//     // const filteredCity = citiesArray.filter(city => city.city.toLowerCase().includes(searchInput.toLowerCase()))

//     // useEffect(() => {
//     //     console.log("Filtered Cities:", filteredCity);
//     // }, [filteredCity]);

//     const handleCityClick = (city: string) => {
//         console.log(city, "city from dropdown");
//         setSearchInput(city);         // Show the city name in input
//         setSelectedCity(city);        // Optional: track selected city
//         setShowDropdown(false);

//         if (!city.trim()) {
//             setError(true)
//             return;
//         }
//         localStorage.setItem("selectedCity", city)
//         localStorage.setItem("selectedCity", city);
//         navigate("/onbording6");

//     };

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setSearchInput(value);
//         setShowDropdown(value.length > 0); // Show dropdown if input has text
//     };

//     const handleClearInput = () => {
//         setSearchInput("")
//         setShowDropdown(false)
//     }

//     const [showLocationPopup, setShowLocationPopup] = useState(false);

//     // useEffect(() => {
//     //     // alert("Open Your Current Location")
//     //     // Open popup on mount
//     //     const hasSeenPopup = localStorage.getItem("locationPopupShown");
//     //     if (!hasSeenPopup) {
//     //         setTimeout(() => {
//     //             setShowLocationPopup(true);
//     //             localStorage.setItem("locationPopupShown", "true");
//     //         }, 1000);
//     //     }
//     // }, [pathname])

//     const hanldeAllowLocation = (location: string) => {
//         setShowLocationPopup(false);

//         if (location === "Allow") {
//             console.log("this is Allow Block");

//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(
//                     (position) => {
//                         const { latitude, longitude } = position.coords;
//                         console.log("User location:", latitude, longitude);

//                         // You can use these coordinates to fetch nearby options or update your app state
//                     },
//                     (error) => {
//                         console.error("Geolocation error:", error.message);
//                     }
//                 );
//             } else {
//                 console.error("Geolocation is not supported by this browser.");
//             }
//         }

//         if (location === "Don't Allow") {
//             console.log("This is Don't Allow Block");
//         }
//     };

//     const handleCityClick2 = (selectCity: string) => {
//         console.log("city is here", selectCity)
//         localStorage.setItem("selectedCity", selectCity)
//         navigate("/onbording6")
//     }

//     // ***********Start the Reuseable Component*********************************
//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity'>   You are looking to rent in</p>
//             </div>
//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 {/* <div className="searchBar" style={{ border: error ? "1px solid red" : "1px solid #ddd", }}>
//                     <span><svg.SearchSvg /></span>
//                     <input
//                         type="text"
//                         placeholder="Search City here"
//                         className="searchInput"
//                         maxLength={30}
//                         value={searchInput}
//                         onChange={(e) => {
//                             handleInputChange(e);
//                             if (error) setError(false);
//                         }}

//                     />

//                     {
//                         searchInput && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>

//                 {showDropdown && (
//                     <div className='localityResult'>
//                         {filteredCity.length > 0 ? (
//                             filteredCity.map((city, index) => (
//                                 <p key={index} onClick={() => handleCityClick(city.city)}>{city.city}</p>
//                             ))
//                         ) : (
//                             <p style={{ backgroundColor: "#f0f0f0", color: "#333" }}>No cities found</p>
//                         )}
//                     </div>
//                 )}

//                 {
//                     error && <div style={{ fontSize: "15px", color: "red" }}>
//                         Please Enter & Select City Name
//                     </div>
//                 } */}
//                 {/* <div className="useLocation" onClick={handleUseLocation}>
//                     <svg.LocationSvg />
//                     <span >Use My Current Location</span>
//                 </div> */}
//             </div>
//         );
//     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 10 }}>
//                 <p className='paraCity'>Choose a city here which can be changed later on</p>
//             </div>
//         );
//     };
//     const renderDescription1 = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 40 }}>
//                 <p className='popularCity'  >Please select your <span> City</span> </p>
//             </div>
//         );
//     };

//     const locations = [
//         'Delhi', 'Noida', 'Gurugram',
//     ];

//     // OLD LOCATION GRID
//     const renderLocationGrid = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div className="location-container">
//                     <div className="location-scroll">
//                         <div className="location-grid">
//                             {locations.map((city, index) => (
//                                 <div className="location-card" key={index} onClick={() => handleCityTab(city)}>
//                                     {city}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const locationMap = [
//         {
//             id: 1,
//             cityName: "Noida",
//             cityImage: "https://img.freepik.com/free-photo/illuminated-city-night_1127-2144.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
//         },
//         {
//             id: 2,
//             cityName: "Delhi",
//             cityImage: "https://img.freepik.com/premium-photo/canopy-india-gate-sunset-new-delhi-view-from-national-war-memorial_400112-339.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740"
//         },
//         {
//             id: 3,
//             cityName: "Gurugram",
//             cityImage: "https://media.istockphoto.com/id/1416839998/photo/dlf-cyber-city-in-gurgaon.jpg?s=612x612&w=0&k=20&c=y2nVWLc_5RkHmUjc6L2h_3sGka-FZGeo-BmP3nUpMDk="
//         }
//     ]

//     const renderLocationGrid2 = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div className="cityContainer">
//                     {
//                         locationMap.map((city, index) => (
//                             <div className="cities" style={{ backgroundImage: `url(${city.cityImage})` }} key={index} onClick={() => handleCityClick2(city.cityName)}>
//                                 <span className="city-name">{city.cityName}</span>
//                             </div>
//                         ))
//                     }
//                 </div>
//             </div>
//         );
//     };

//     // const renderButton = (): JSX.Element => {
//     //     return (

//     //         <div
//     //             id="onbording3"
//     //             style={{ backgroundColor: "#7065F0", color: "white" }}
//     //             onClick={handleApply}
//     //         >
//     //             <span>Apply</span>
//     //         </div>
//     //     );
//     // };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh',
//                     paddingBottom: 10,
//                     overflow: 'hidden',
//                 }}
//             >
//                 <div style={{ overflowY: 'auto' }}>
//                     {renderTitle()}
//                     {renderDescription()}
//                     {renderDescription1()}
//                     {renderSearchBar()}
//                     {renderLocationGrid2()}
//                     {/* {renderLocationGrid()} */}

//                 </div>
//                 {/*
//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div> */}
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {showLocationPopup &&
//                 <div className='location-overlay'>
//                     <div className="location-modal">
//                         <div className='location-buttons'>
//                             <div className='img-container'>
//                                 <img src={locationAllow} alt="Location" width="100" />
//                             </div>
//                             <div className="locationContent">
//                                 <h3>Allow your location </h3>
//                                 <p>
//                                     To help you find the best options near you, we need access to your location.
//                                     Your privacy is important to us.
//                                 </p>
//                             </div>
//                             <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
//                             <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
//                         </div>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };

// import React, { useState, useEffect } from 'react';
// import { useFetcher, useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { encryptData } from "../utils/crypto";
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import locationAllow from '../assets/nestfin/map.png'

// const price = [
//     {
//         id: 1,
//         name: 'Paid (142)',
//     },
//     {
//         id: 2,
//         name: 'Free (18)',
//     },
// ];

// export const Onboarding5: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const navigate = hooks.useNavigate();

//     const [selectedPrice, setSelectedPrice] = useState<number | null>(price[0].id);
//     const [searchInput, setSearchInput] = useState<string>('');
//     const [selectedCity, setSelectedCity] = useState("");
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [error, setError] = useState(false);

//     const handleUseLocation = () => {
//         if ('geolocation' in navigator) {
//             navigator.geolocation.getCurrentPosition(
//                 (position) => {
//                     const latitude = position.coords.latitude;
//                     const longitude = position.coords.longitude;

//                     console.log('Latitude:', latitude);
//                     console.log('Longitude:', longitude);

//                     // You can use latitude and longitude here to fetch address or nearby data
//                 },
//                 (error) => {
//                     console.error('Geolocation error:', error.message);
//                     alert('Unable to fetch location. Please allow location access.');
//                 }
//             );
//         } else {
//             alert('Geolocation is not supported in your browser.');
//         }
//     };

//     // const handleApply = () => {
//     //     if (searchInput.trim()) {
//     //         localStorage.setItem("selectedCity", searchInput);
//     //         navigate("/onbording6", { state: { cityName: searchInput } });
//     //     } else {
//     //         alert("Please enter a city name");
//     //     }
//     // };

//     const handleApply = () => {
//         if (!searchInput.trim()) {
//             setError(true)
//             return;
//         }
//         localStorage.setItem("selectedCity", searchInput)
//         localStorage.setItem("selectedCity", searchInput);
//         navigate("/onbording6", { state: { cityName: searchInput } });
//     };

//     // handleCityTab

//     const handleCityTab = (cityName: string) => {
//         console.log(cityName, "this is city name");
//         setSearchInput(cityName);
//         localStorage.setItem("selectedCity", cityName);
//         navigate("/onbording6", { state: { cityName } });
//     }

//     const citiesArray = [
//         { id: 1, city: "Delhi" },
//         { id: 2, city: "New Delhi" },
//         { id: 3, city: "Noida" },
//         { id: 4, city: "Greater Noida" },
//         { id: 5, city: "Gurugram" },
//         { id: 6, city: "Faridabad" },
//         { id: 7, city: "Ghaziabad" },
//         // { id: 8, city: "Sonipat" },
//         // { id: 9, city: "Panipat" },
//         // { id: 10, city: "Meerut" },
//         // { id: 11, city: "Bahadurgarh" },
//         // { id: 12, city: "Rohtak" },
//         // { id: 13, city: "Palwal" },
//         // { id: 14, city: "Ballabhgarh" },
//         // { id: 15, city: "Modinagar" },
//     ];

//     const filteredCity = citiesArray.filter(city => city.city.toLowerCase().includes(searchInput.toLowerCase()))

//     useEffect(() => {
//         console.log("Filtered Cities:", filteredCity);
//     }, [filteredCity]);

//     const handleCityClick = (city: string) => {
//         console.log(city, "city from dropdown");
//         setSearchInput(city);         // Show the city name in input
//         setSelectedCity(city);        // Optional: track selected city
//         setShowDropdown(false);

//         if (!city.trim()) {
//             setError(true)
//             return;
//         }
//         localStorage.setItem("selectedCity", city)
//         localStorage.setItem("selectedCity", city);
//         navigate("/onbording6");

//     };

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setSearchInput(value);
//         setShowDropdown(value.length > 0); // Show dropdown if input has text
//     };

//     const handleClearInput = () => {
//         setSearchInput("")
//         setShowDropdown(false)
//     }

//     const [showLocationPopup, setShowLocationPopup] = useState(false);

//     useEffect(() => {
//         // alert("Open Your Current Location")
//         // Open popup on mount
//         setTimeout(() => {
//             setShowLocationPopup(true);
//         }, 1000);
//     }, [pathname])

//     const hanldeAllowLocation = (location: string) => {
//         setShowLocationPopup(false);

//         if (location === "Allow") {
//             console.log("this is Allow Block");

//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(
//                     (position) => {
//                         const { latitude, longitude } = position.coords;
//                         console.log("User location:", latitude, longitude);

//                         // You can use these coordinates to fetch nearby options or update your app state
//                     },
//                     (error) => {
//                         console.error("Geolocation error:", error.message);
//                     }
//                 );
//             } else {
//                 console.error("Geolocation is not supported by this browser.");
//             }
//         }

//         if (location === "Don't Allow") {
//             console.log("This is Don't Allow Block");
//         }
//     };

//     // Start the Reuseable Component
//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity'>   You are looking to rent in</p>
//                 {/* <text.H2
//                     style={{
//                         textTransform: 'capitalize',
//                         color: "#7065F0",
//                     }}
//                 >
//                     You are looking to rent in
//                 </text.H2> */}
//             </div>
//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div className="searchBar" style={{ border: error ? "1px solid red" : "1px solid #ddd", }}>
//                     <span><svg.SearchSvg /></span>
//                     <input
//                         type="text"
//                         placeholder="Search City here"
//                         className="searchInput"
//                         maxLength={30}
//                         value={searchInput}
//                         onChange={(e) => {
//                             handleInputChange(e);
//                             if (error) setError(false);
//                         }}

//                     />

//                     {
//                         searchInput && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>

//                 {showDropdown && (
//                     <div className='localityResult'>
//                         {filteredCity.length > 0 ? (
//                             filteredCity.map((city, index) => (
//                                 <p key={index} onClick={() => handleCityClick(city.city)}>{city.city}</p>
//                             ))
//                         ) : (
//                             <p style={{ backgroundColor: "#f0f0f0", color: "#333" }}>No cities found</p>
//                         )}
//                     </div>
//                 )}

//                 {
//                     error && <div style={{ fontSize: "15px", color: "red" }}>
//                         Please Enter & Select City Name
//                     </div>
//                 }
//                 <div className="useLocation" onClick={handleUseLocation}>
//                     <svg.LocationSvg />
//                     <span>Use My Current Location</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 10 }}>

//                 <p className='paraCity'>Choose a city here which can be changed later on</p>
//                 {/* <text.T18
//                     style={{
//                         lineHeight: 1,
//                         whiteSpace: 'pre-line',
//                     }}
//                 >
//                     Choose a city here which can be changed later on
//                 </text.T18> */}
//             </div>
//         );
//     };
//     const renderDescription1 = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 40 }}>
//                 <p className='popularCity'  >Please select from <span>Popular Cities</span> </p>
//             </div>
//         );
//     };

//     const locations = [
//         'Delhi', 'Noida', 'Gurugram',
//     ];

//     const renderLocationGrid = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div className="location-container">
//                     <div className="location-scroll">
//                         <div className="location-grid">
//                             {locations.map((city, index) => (
//                                 <div className="location-card" key={index} onClick={() => handleCityTab(city)}>
//                                     {city}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };
//     const renderButton = (): JSX.Element => {
//         return (

//             <div
//                 id="onbording3"
//                 style={{ backgroundColor: "#7065F0", color: "white" }}
//                 onClick={handleApply}
//             >
//                 <span>Apply</span>
//             </div>

//             // <components.Button
//             //     title='Apply'
//             //     style={{
//             //         backgroundColor: '#7065F0',
//             //         color: '#fff',
//             //         border: '1px solid #7065F0',
//             //     }}
//             //     onClick={() => navigate('/onbording6')}
//             // />
//         );
//     };

//     // const locations = [
//     //     'Mumbai', 'Delhi', 'Bengaluru',
//     //     'Hyderabad', 'Ahmedabad', 'Chennai',
//     //     'Kolkata', 'Pune', 'Jaipur',
//     //     'Surat', 'Lucknow', 'Nagpur',
//     //     'Indore', 'Bhopal', 'Patna',
//     //     'Vadodara', 'Kanpur', 'Ludhiana',
//     //     'Agra', 'Coimbatore'
//     // ];

//     // const renderLocationGrid = (): JSX.Element => {
//     //     return (
//     //         <div className="container" style={{ marginTop: 20 }}>
//     //             <div
//     //                 style={{
//     //                     maxHeight: 400, // adjust height as needed
//     //                     overflowY: 'auto',
//     //                 }}
//     //             >
//     //                 <div
//     //                     style={{
//     //                         display: 'grid',
//     //                         gap: 10,
//     //                         gridTemplateColumns: 'repeat(3, 1fr)',
//     //                     }}
//     //                     className="location-grid"
//     //                 >
//     //                     {locations.map((city, index) => (
//     //                         <div
//     //                             key={index}
//     //                             style={{
//     //                                 padding: '12px',
//     //                                 border: '1px solid #ccc',
//     //                                 borderRadius: 5,
//     //                                 textAlign: 'center',
//     //                                 fontSize: 14,
//     //                                 backgroundColor: '#f9f9f9',
//     //                             }}
//     //                         >
//     //                             {city}
//     //                         </div>
//     //                     ))}
//     //                 </div>
//     //             </div>

//     //             <style>
//     //                 {`
//     //                 @media (min-width: 768px) {
//     //                     .location-grid {
//     //                         grid-template-columns: repeat(5, 1fr) !important;
//     //                     }
//     //                 }

//     //                 /* Optional: smooth scroll or scroll styling */
//     //                 .location-grid::-webkit-scrollbar {
//     //                     width: 6px;
//     //                 }
//     //                 .location-grid::-webkit-scrollbar-thumb {
//     //                     background-color: rgba(0, 0, 0, 0.2);
//     //                     border-radius: 4px;
//     //                 }
//     //             `}
//     //             </style>
//     //         </div>
//     //     );
//     // };

//     // const renderSearchBar = (): JSX.Element => {
//     //     return (
//     //         <div className='container'>
//     //             <div
//     //                 style={{
//     //                     padding: '9px 16px',
//     //                     width: '100%',
//     //                     marginTop: 40,
//     //                     marginBottom: 20,
//     //                     left: 20,
//     //                     top: 24,
//     //                     borderRadius: 5,
//     //                     border: '1px solid #ddd',
//     //                     backgroundColor: '#fff',
//     //                     ...utils.rowCenter(),
//     //                 }}
//     //             >
//     //                 <svg.SearchSvg />
//     //                 <text.T14 style={{ marginLeft: 8, marginRight: 'auto' }}>
//     //                     Search City here
//     //                 </text.T14>
//     //                 <div
//     //                     style={{ cursor: 'pointer' }}
//     //                 // onClick={() => navigate('/filter')}
//     //                 >
//     //                     {/* <svg.FilterSvg /> */}
//     //                 </div>
//     //             </div>
//     //         </div>
//     //     );
//     // };

//     // const renderLocationGrid = (): JSX.Element => {
//     //     return (
//     //         <div
//     //             className="container"
//     //             style={{
//     //                 marginTop: 20,
//     //             }}
//     //         >
//     //             <div
//     //                 style={{
//     //                     display: 'grid',
//     //                     gap: 10,
//     //                     gridTemplateColumns: 'repeat(3, 1fr)',
//     //                 }}
//     //             >
//     //                 {locations.map((city, index) => (
//     //                     <div
//     //                         key={index}
//     //                         style={{
//     //                             padding: '12px',
//     //                             border: '1px solid #ccc',
//     //                             borderRadius: 5,
//     //                             textAlign: 'center',
//     //                             fontSize: 14,
//     //                             backgroundColor: '#f9f9f9',
//     //                         }}
//     //                     >
//     //                         {city}
//     //                     </div>
//     //                 ))}
//     //             </div>
//     //             <style>
//     //                 {`
//     //                     @media (min-width: 768px) {
//     //                         .container > div {
//     //                             grid-template-columns: repeat(5, 1fr) !important;
//     //                         }
//     //                     }
//     //                 `}
//     //             </style>
//     //         </div>
//     //     );
//     // };

//     const renderContent = (): JSX.Element => {
//         return (
//             // <main
//             //     className=''
//             //     style={{
//             //         display: 'flex',
//             //         flexDirection: 'column',
//             //         justifyContent: 'space-between',
//             //         minHeight: '100vh',
//             //         paddingBottom: 10,
//             //     }}
//             // >
//             //     <div>
//             //         {renderTitle()}
//             //         {renderDescription()}
//             //         {renderSearchBar()}
//             //         {renderDescription1()}
//             //         {renderLocationGrid()}
//             //     </div>
//             //     <div style={{
//             //         paddingRight: 20,
//             //         paddingLeft: 20,
//             //     }}>
//             //         {renderButton()}
//             //     </div>
//             // </main>
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh',
//                     paddingBottom: 10,
//                     overflow: 'hidden',
//                 }}
//             >
//                 <div style={{ overflowY: 'auto' }}>
//                     {renderTitle()}
//                     {renderDescription()}
//                     {renderSearchBar()}
//                     {renderDescription1()}
//                     {renderLocationGrid()}
//                 </div>
//                 {/*
//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div> */}
//             </main>

//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {showLocationPopup &&
//                 <div className='location-overlay'>
//                     <div className="location-modal">
//                         <div className='location-buttons'>
//                             <div className='img-container'>
//                                 <img src={locationAllow} alt="Location" width="100" />
//                             </div>
//                             <div className="locationContent">
//                                 <h3>Allow your location </h3>
//                                 <p>
//                                     To help you find the best options near you, we need access to your location.
//                                     Your privacy is important to us.
//                                 </p>
//                             </div>
//                             <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
//                             <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
//                         </div>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };
